<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="80%"
  >
    <div class="enterprise-member-container clearfix">
      <div class="left fl">
        <div class="header">会员列表</div>
        <el-table
          v-loading="loading"
          :data="memberList"
          border
          size="mini"
          ref="leftTable"
          @selection-change="handleSelectionChange"
          style="width: 100%;height: calc(100% - 40px);overflow-y: auto;"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="name"
            label="会员名称">
          </el-table-column>
          <el-table-column
            prop="mobilePhone"
            label="手机号">
          </el-table-column>
        </el-table>
      </div>
      <div class="center fl">
        <el-button
          style="width: 120px"
          size="mini"
          type="primary"
          @click="addRightEnterpriseMember"
        >
          添加成员
        </el-button>
      </div>
      <div class="right fl">
        <div class="header">企业成员</div>
        <el-table
          :data="checkMemberList"
          v-loading="loadingR"
          border
          size="mini"
          style="width: 100%;height: calc(100% - 40px);overflow-y: auto;"
        >
          <el-table-column
            prop="name"
            label="会员名称">
          </el-table-column>
          <el-table-column
            prop="mobilePhone"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="name"
            label="是否为负责人">
            <template slot-scope="{ $index, row }">
              <el-switch :value="row.isManager" @change="e => changeIsManager(e, $index, row)" />
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            fixed="right"
            label="操作"
          >
            <template slot-scope="{ $index }">
              <el-button
                type="danger"
                @click="del($index)"
                size="mini"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getUser, addEnterpriseMember } from 'api/request'
  export default {
    data() {
      return {
        title: '编辑企业成员',
        visible: false,
        loading: false,
        loadingR: false,
        loadingSubmit: false,
        // 表单参数
        form: {
          enterpriseId: undefined,
          panelIds: [],
        },
        // 表单校验
        rules: {
        
        },
        enterpriseMemberList: [],
        memberList: [],
        leftCheckMemberList: [],
        checkMemberList: []
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
    },
    methods: {
      show(data) {
        this.form.enterpriseId = data.enterpriseId
        this.getMemberList(data)
        this.visible = true
      },
      async getMemberList(defaultData) {
        this.loading = true
        let data = await getUser({ PageIndex: 1, PageSize: 9999 })
        if (data && data.rows && Array.isArray(data.rows)) {
          let dataList = data.rows
          dataList.forEach((item, index) => {
            item.idx = index
          })
          this.memberList = dataList
          if (defaultData.panels) {
            let defCheckMemberList = defaultData.panels.map(v => v.id)
            this.$nextTick(() => {
              let temCheckMemberList = []
              this.memberList.forEach(v => {
                if (defCheckMemberList.includes(v.id)) {
                  temCheckMemberList.push(v)
                  this.$refs.leftTable.toggleRowSelection(v, true)
                }
              })
              defaultData.panels.forEach(v => {
                temCheckMemberList.forEach(cV => {
                  if (cV.id === v.id) {
                    cV.isManager = v.isManager
                  }
                })
              })
              this.checkMemberList = temCheckMemberList.sort((a, b) => a.idx - b.idx)
            })
          }
        }
        this.loading = false
      },
      submitForm() {
        this.loadingSubmit = true
        let params = {
          enterpriseId: this.form.enterpriseId,
          enterpriseMembers: this.checkMemberList.map(v => {
            return {
              penelId: v.id,
              isManager: v.isManager,
            }
          })
        }
        addEnterpriseMember(params).then(res => {
          this.loadingSubmit = false;
          if (res) {
            this.$emit('done');
            this.$message.success('操作成功');
            this.loadingSubmit = false
            this.visible = false;
          } else {
            this.loadingSubmit = false
          }
        }).catch(() => {
          this.loadingSubmit = false
        })
      },
      /** 选择会员 */
      handleSelectionChange(val) {
        this.leftCheckMemberList = val
      },
      addRightEnterpriseMember() {
        this.loadingR = true
        let rCheckMemberList = JSON.parse(JSON.stringify(this.checkMemberList)).map(v => v.id)
        let pushMemberList = []
        this.leftCheckMemberList.forEach(v => {
          if (!rCheckMemberList.includes(v.id)) {
            pushMemberList.push(v);
          }
        })
        pushMemberList.forEach(v => {
          v.isManager = false
        })
        this.checkMemberList.push(...pushMemberList);
        this.checkMemberList = this.checkMemberList.sort((a, b) => a.idx - b.idx)
        this.loadingR = false
      },
      changeIsManager(boll, idx, row) {
        this.$set(row, 'isManager', boll)
        this.$set(this.checkMemberList, idx, row)
      },
      del(idx) {
        this.checkMemberList.splice(idx, 1)
      },
      /*取消*/
      cancel () {
        Object.assign(this.$data, this.$options.data.call(this));
      },
    }
  }
</script>

<style lang="scss">
  .dialog-footer{
    text-align: center;
  }
  .clearfix:after {
    clear: both;
    display: block;
    content: "";
    height: 0
  }
  .enterprise-member-container{
    width: 100%;
    height: 400px;
    .fl{
      float: left;
    }
    .left,.right{
      height: 100%;
      width: calc(50% - 75px);
      .header{
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        background-color: #049EA3;
        color: #fff;
      }
    }
    .center{
      height: 100%;
      width: 150px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
